export default __webpack_public_path__ + "static/trustify-sources-s-253c9f53c0c475c28e4768c6db9dcab5.png";